<div id="shared-schedule-popover" class="shared-schedule-popover">
  <div class="row">
    <div class="col-xs-12">
      <button
        type="button"
        class="close"
        (click)="dismiss()"
        aria-label="Click to close this modal"
      >
        <streamline-icon name="close" width="10" height="10"></streamline-icon>
      </button>
      <span
        class="text-sm font-weight-bold"
        [shown]="currentTab === 'link'"
        (click)="$event.stopPropagation()"
        >Share</span
      >
    </div>
  </div>

  <div
    [shown]="currentTab === 'link'"
    class="row u_margin-sm-top"
    (click)="$event.stopPropagation()"
  >
    <div class="col-xs-12 aligner">
      <input
        #linkText
        class="form-control copy-text-box w-100"
        type="text"
        readonly="readonly"
        [value]="getLink()"
        (focus)="onTextFocus($event)"
      />
      <button
        rv-button
        type="button"
        id="copyUrlButton"
        class="ml-2"
        (click)="copyToClipboard(getLink())"
        aria-label="Copy"
      >
        Copy
      </button>
    </div>
  </div>

  @if (scheduleService.hasInsecureUrls(scheduleService.schedule)) {
    <div class="mt-3" (click)="$event.stopPropagation()">
      <notification-alert id="shared-schedule-insecure-error" type="danger">
        @if (!isScheduleDetails) {
          <p>
            Some content in this schedule won't be shown.
            <br />
            <a
              rv-link
              appearance="inline"
              href="#"
              uiSref="apps.schedules.details({ scheduleId: schedule.id, cid: schedule.companyId })"
              >Fix this.</a
            >
          </p>
        } @else {
          <p>
            Some playlist items in your schedule are using an insecure URL
            (HTTP) and won't be shown. Use secure URLs (HTTPS) instead.
          </p>
        }
      </notification-alert>
    </div>
  }
</div>
